// Page icons are stored as Eva icon names: the legacy mobile app renders Eva
// directly, so the stored value must not change. Web and mobile-next draw
// Ionicons and translate through this map at render time.
export const EVA_TO_IONICONS = {
  activity: "pulse",
  "alert-circle": "alert-circle",
  "alert-triangle": "warning",
  archive: "archive",
  "arrow-back": "arrow-back",
  "arrow-circle-down": "arrow-down-circle",
  "arrow-circle-left": "arrow-back-circle",
  "arrow-circle-right": "arrow-forward-circle",
  "arrow-circle-up": "arrow-up-circle",
  "arrow-down": "arrow-down",
  "arrow-downward": "arrow-down",
  "arrow-forward": "arrow-forward",
  "arrow-ios-back": "chevron-back",
  "arrow-ios-downward": "chevron-down",
  "arrow-ios-forward": "chevron-forward",
  "arrow-ios-upward": "chevron-up",
  "arrow-left": "arrow-back",
  "arrow-right": "arrow-forward",
  "arrow-up": "arrow-up",
  "arrow-upward": "arrow-up",
  "arrowhead-down": "chevron-down",
  "arrowhead-left": "chevron-back",
  "arrowhead-right": "chevron-forward",
  "arrowhead-up": "chevron-up",
  at: "at",
  "attach-2": "attach",
  attach: "attach",
  award: "ribbon",
  backspace: "backspace",
  "bar-chart-2": "bar-chart",
  "bar-chart": "bar-chart",
  battery: "battery-half",
  behance: "logo-behance",
  "bell-off": "notifications-off",
  bell: "notifications",
  bluetooth: "bluetooth",
  "book-open": "book",
  book: "book",
  bookmark: "bookmark",
  briefcase: "briefcase",
  browser: "browsers",
  brush: "brush",
  bulb: "bulb",
  calendar: "calendar",
  camera: "camera",
  car: "car",
  cast: "tv",
  charging: "battery-charging",
  "checkmark-circle-2": "checkmark-circle",
  "checkmark-circle": "checkmark-circle",
  "checkmark-square-2": "checkbox",
  "checkmark-square": "checkbox",
  checkmark: "checkmark",
  "chevron-down": "chevron-down",
  "chevron-left": "chevron-back",
  "chevron-right": "chevron-forward",
  "chevron-up": "chevron-up",
  clipboard: "clipboard",
  clock: "time",
  "close-circle": "close-circle",
  "close-square": "close-circle",
  close: "close",
  "cloud-download": "cloud-download",
  "cloud-upload": "cloud-upload",
  "code-download": "code-download",
  code: "code",
  collapse: "contract",
  "color-palette": "color-palette",
  "color-picker": "eyedrop",
  compass: "compass",
  copy: "copy",
  "corner-down-left": "return-down-back",
  "corner-down-right": "return-down-forward",
  "corner-left-down": "return-down-back",
  "corner-left-up": "return-up-back",
  "corner-right-down": "return-down-forward",
  "corner-right-up": "return-up-forward",
  "corner-up-left": "return-up-back",
  "corner-up-right": "return-up-forward",
  "credit-card": "card",
  crop: "crop",
  cube: "cube",
  "diagonal-arrow-left-down": "trending-down",
  "diagonal-arrow-left-up": "trending-up",
  "diagonal-arrow-right-down": "trending-down",
  "diagonal-arrow-right-up": "trending-up",
  "done-all": "checkmark-done",
  download: "download",
  "droplet-off": "water",
  droplet: "water",
  "edit-2": "create",
  edit: "create",
  email: "mail",
  expand: "expand",
  "external-link": "open",
  "eye-off-2": "eye-off",
  "eye-off": "eye-off",
  eye: "eye",
  facebook: "logo-facebook",
  "file-add": "document-attach",
  "file-remove": "document",
  "file-text": "document-text",
  file: "document",
  film: "film",
  flag: "flag",
  "flash-off": "flash-off",
  flash: "flash",
  "flip-2": "swap-vertical",
  flip: "swap-horizontal",
  "folder-add": "folder-open",
  "folder-remove": "folder",
  folder: "folder",
  funnel: "funnel",
  gift: "gift",
  github: "logo-github",
  "globe-2": "earth",
  "globe-3": "earth",
  globe: "globe",
  google: "logo-google",
  grid: "grid",
  "hard-drive": "server",
  hash: "pricetag",
  headphones: "headset",
  heart: "heart",
  home: "home",
  "image-2": "images",
  image: "image",
  inbox: "file-tray",
  info: "information-circle",
  keypad: "keypad",
  layers: "layers",
  layout: "grid",
  "link-2": "link",
  link: "link",
  linkedin: "logo-linkedin",
  list: "list",
  lock: "lock-closed",
  "log-in": "log-in",
  "log-out": "log-out",
  map: "map",
  maximize: "expand",
  "menu-2": "menu",
  "menu-arrow": "menu",
  menu: "menu",
  "message-circle": "chatbubble",
  "message-square": "chatbox",
  "mic-off": "mic-off",
  mic: "mic",
  minimize: "contract",
  "minus-circle": "remove-circle",
  "minus-square": "remove",
  minus: "remove",
  monitor: "desktop",
  moon: "moon",
  "more-horizontal": "ellipsis-horizontal",
  "more-vertical": "ellipsis-vertical",
  move: "move",
  music: "musical-notes",
  "navigation-2": "navigate",
  navigation: "navigate",
  npm: "logo-npm",
  "options-2": "options",
  options: "options",
  pantone: "color-palette",
  "paper-plane": "paper-plane",
  "pause-circle": "pause-circle",
  people: "people",
  percent: "calculator",
  "person-add": "person-add",
  "person-delete": "person-remove",
  "person-done": "person",
  "person-remove": "person-remove",
  person: "person",
  "phone-call": "call",
  "phone-missed": "call",
  "phone-off": "call",
  phone: "call",
  "pie-chart-2": "pie-chart",
  "pie-chart": "pie-chart",
  pin: "pin",
  "play-circle": "play-circle",
  "plus-circle": "add-circle",
  "plus-square": "add",
  plus: "add",
  power: "power",
  pricetags: "pricetags",
  printer: "print",
  "question-mark-circle": "help-circle",
  "question-mark": "help",
  "radio-button-off": "radio-button-off",
  "radio-button-on": "radio-button-on",
  radio: "radio",
  recording: "recording",
  refresh: "refresh",
  repeat: "repeat",
  "rewind-left": "play-back",
  "rewind-right": "play-forward",
  save: "save",
  scissors: "cut",
  search: "search",
  "settings-2": "settings",
  settings: "settings",
  shake: "phone-portrait",
  share: "share",
  "shield-off": "shield",
  shield: "shield",
  "shopping-bag": "bag",
  "shopping-cart": "cart",
  "shuffle-2": "shuffle",
  shuffle: "shuffle",
  "skip-back": "play-skip-back",
  "skip-forward": "play-skip-forward",
  slash: "ban",
  smartphone: "phone-portrait",
  "smiling-face": "happy",
  speaker: "volume-high",
  square: "square",
  star: "star",
  "stop-circle": "stop-circle",
  sun: "sunny",
  swap: "swap-horizontal",
  sync: "sync",
  text: "text",
  "thermometer-minus": "thermometer",
  "thermometer-plus": "thermometer",
  thermometer: "thermometer",
  "toggle-left": "toggle",
  "toggle-right": "toggle",
  "trash-2": "trash",
  trash: "trash",
  "trending-down": "trending-down",
  "trending-up": "trending-up",
  tv: "tv",
  twitter: "logo-twitter",
  umbrella: "umbrella",
  undo: "arrow-undo",
  unlock: "lock-open",
  upload: "cloud-upload",
  "video-off": "videocam-off",
  video: "videocam",
  "volume-down": "volume-low",
  "volume-mute": "volume-mute",
  "volume-off": "volume-off",
  "volume-up": "volume-high",
  "wifi-off": "wifi",
  wifi: "wifi",
  "activity-outline": "pulse-outline",
  "alert-circle-outline": "alert-circle-outline",
  "alert-triangle-outline": "warning-outline",
  "archive-outline": "archive-outline",
  "arrow-back-outline": "arrow-back-outline",
  "arrow-circle-down-outline": "arrow-down-circle-outline",
  "arrow-circle-left-outline": "arrow-back-circle-outline",
  "arrow-circle-right-outline": "arrow-forward-circle-outline",
  "arrow-circle-up-outline": "arrow-up-circle-outline",
  "arrow-down-outline": "arrow-down-outline",
  "arrow-downward-outline": "arrow-down-outline",
  "arrow-forward-outline": "arrow-forward-outline",
  "arrow-ios-back-outline": "chevron-back-outline",
  "arrow-ios-downward-outline": "chevron-down-outline",
  "arrow-ios-forward-outline": "chevron-forward-outline",
  "arrow-ios-upward-outline": "chevron-up-outline",
  "arrow-left-outline": "arrow-back-outline",
  "arrow-right-outline": "arrow-forward-outline",
  "arrow-up-outline": "arrow-up-outline",
  "arrow-upward-outline": "arrow-up-outline",
  "arrowhead-down-outline": "chevron-down-outline",
  "arrowhead-left-outline": "chevron-back-outline",
  "arrowhead-right-outline": "chevron-forward-outline",
  "arrowhead-up-outline": "chevron-up-outline",
  "at-outline": "at-outline",
  "attach-2-outline": "attach-outline",
  "attach-outline": "attach-outline",
  "award-outline": "ribbon-outline",
  "backspace-outline": "backspace-outline",
  "bar-chart-2-outline": "bar-chart-outline",
  "bar-chart-outline": "bar-chart-outline",
  "battery-outline": "battery-half-outline",
  "behance-outline": "logo-behance",
  "bell-off-outline": "notifications-off-outline",
  "bell-outline": "notifications-outline",
  "bluetooth-outline": "bluetooth-outline",
  "book-open-outline": "book-outline",
  "book-outline": "book-outline",
  "bookmark-outline": "bookmark-outline",
  "briefcase-outline": "briefcase-outline",
  "browser-outline": "browsers-outline",
  "brush-outline": "brush-outline",
  "bulb-outline": "bulb-outline",
  "calendar-outline": "calendar-outline",
  "camera-outline": "camera-outline",
  "car-outline": "car-outline",
  "cast-outline": "tv-outline",
  "charging-outline": "battery-charging-outline",
  "checkmark-circle-2-outline": "checkmark-circle-outline",
  "checkmark-circle-outline": "checkmark-circle-outline",
  "checkmark-outline": "checkmark-outline",
  "checkmark-square-2-outline": "checkbox-outline",
  "checkmark-square-outline": "checkbox-outline",
  "chevron-down-outline": "chevron-down-outline",
  "chevron-left-outline": "chevron-back-outline",
  "chevron-right-outline": "chevron-forward-outline",
  "chevron-up-outline": "chevron-up-outline",
  "clipboard-outline": "clipboard-outline",
  "clock-outline": "time-outline",
  "close-circle-outline": "close-circle-outline",
  "close-outline": "close-outline",
  "close-square-outline": "close-circle-outline",
  "cloud-download-outline": "cloud-download-outline",
  "cloud-upload-outline": "cloud-upload-outline",
  "code-download-outline": "code-download-outline",
  "code-outline": "code-outline",
  "collapse-outline": "contract-outline",
  "color-palette-outline": "color-palette-outline",
  "color-picker-outline": "eyedrop-outline",
  "compass-outline": "compass-outline",
  "copy-outline": "copy-outline",
  "corner-down-left-outline": "return-down-back-outline",
  "corner-down-right-outline": "return-down-forward-outline",
  "corner-left-down-outline": "return-down-back-outline",
  "corner-left-up-outline": "return-up-back-outline",
  "corner-right-down-outline": "return-down-forward-outline",
  "corner-right-up-outline": "return-up-forward-outline",
  "corner-up-left-outline": "return-up-back-outline",
  "corner-up-right-outline": "return-up-forward-outline",
  "credit-card-outline": "card-outline",
  "crop-outline": "crop-outline",
  "cube-outline": "cube-outline",
  "diagonal-arrow-left-down-outline": "trending-down-outline",
  "diagonal-arrow-left-up-outline": "trending-up-outline",
  "diagonal-arrow-right-down-outline": "trending-down-outline",
  "diagonal-arrow-right-up-outline": "trending-up-outline",
  "done-all-outline": "checkmark-done-outline",
  "download-outline": "download-outline",
  "droplet-off-outline": "water-outline",
  "droplet-outline": "water-outline",
  "edit-2-outline": "create-outline",
  "edit-outline": "create-outline",
  "email-outline": "mail-outline",
  "expand-outline": "expand-outline",
  "external-link-outline": "open-outline",
  "eye-off-2-outline": "eye-off-outline",
  "eye-off-outline": "eye-off-outline",
  "eye-outline": "eye-outline",
  "facebook-outline": "logo-facebook",
  "file-add-outline": "document-attach-outline",
  "file-outline": "document-outline",
  "file-remove-outline": "document-outline",
  "file-text-outline": "document-text-outline",
  "film-outline": "film-outline",
  "flag-outline": "flag-outline",
  "flash-off-outline": "flash-off-outline",
  "flash-outline": "flash-outline",
  "flip-2-outline": "swap-vertical-outline",
  "flip-outline": "swap-horizontal-outline",
  "folder-add-outline": "folder-open-outline",
  "folder-outline": "folder-outline",
  "folder-remove-outline": "folder-outline",
  "funnel-outline": "funnel-outline",
  "gift-outline": "gift-outline",
  "github-outline": "logo-github",
  "globe-2-outline": "earth-outline",
  "globe-outline": "globe-outline",
  "google-outline": "logo-google",
  "grid-outline": "grid-outline",
  "hard-drive-outline": "server-outline",
  "hash-outline": "pricetag-outline",
  "headphones-outline": "headset-outline",
  "heart-outline": "heart-outline",
  "home-outline": "home-outline",
  "image-outline": "image-outline",
  "inbox-outline": "file-tray-outline",
  "info-outline": "information-circle-outline",
  "keypad-outline": "keypad-outline",
  "layers-outline": "layers-outline",
  "layout-outline": "grid-outline",
  "link-2-outline": "link-outline",
  "link-outline": "link-outline",
  "linkedin-outline": "logo-linkedin",
  "list-outline": "list-outline",
  "loader-outline": "sync-outline",
  "lock-outline": "lock-closed-outline",
  "log-in-outline": "log-in-outline",
  "log-out-outline": "log-out-outline",
  "map-outline": "map-outline",
  "maximize-outline": "expand-outline",
  "menu-2-outline": "menu-outline",
  "menu-arrow-outline": "menu-outline",
  "menu-outline": "menu-outline",
  "message-circle-outline": "chatbubble-outline",
  "message-square-outline": "chatbox-outline",
  "mic-off-outline": "mic-off-outline",
  "mic-outline": "mic-outline",
  "minimize-outline": "contract-outline",
  "minus-circle-outline": "remove-circle-outline",
  "minus-outline": "remove-outline",
  "minus-square-outline": "remove-outline",
  "monitor-outline": "desktop-outline",
  "moon-outline": "moon-outline",
  "more-horizontal-outline": "ellipsis-horizontal-outline",
  "more-vertical-outline": "ellipsis-vertical-outline",
  "move-outline": "move-outline",
  "music-outline": "musical-notes-outline",
  "navigation-2-outline": "navigate-outline",
  "navigation-outline": "navigate-outline",
  "npm-outline": "logo-npm",
  "options-2-outline": "options-outline",
  "options-outline": "options-outline",
  "pantone-outline": "color-palette-outline",
  "paper-plane-outline": "paper-plane-outline",
  "pause-circle-outline": "pause-circle-outline",
  "people-outline": "people-outline",
  "percent-outline": "calculator-outline",
  "person-add-outline": "person-add-outline",
  "person-delete-outline": "person-remove-outline",
  "person-done-outline": "person-outline",
  "person-outline": "person-outline",
  "person-remove-outline": "person-remove-outline",
  "phone-call-outline": "call-outline",
  "phone-missed-outline": "call-outline",
  "phone-off-outline": "call-outline",
  "phone-outline": "call-outline",
  "pie-chart-outline": "pie-chart-outline",
  "pin-outline": "pin-outline",
  "play-circle-outline": "play-circle-outline",
  "plus-circle-outline": "add-circle-outline",
  "plus-outline": "add-outline",
  "plus-square-outline": "add-outline",
  "power-outline": "power-outline",
  "pricetags-outline": "pricetags-outline",
  "printer-outline": "print-outline",
  "question-mark-circle-outline": "help-circle-outline",
  "question-mark-outline": "help-outline",
  "radio-button-off-outline": "radio-button-off-outline",
  "radio-button-on-outline": "radio-button-on-outline",
  "radio-outline": "radio-outline",
  "recording-outline": "recording-outline",
  "refresh-outline": "refresh-outline",
  "repeat-outline": "repeat-outline",
  "rewind-left-outline": "play-back-outline",
  "rewind-right-outline": "play-forward-outline",
  "save-outline": "save-outline",
  "scissors-outline": "cut-outline",
  "search-outline": "search-outline",
  "settings-2-outline": "settings-outline",
  "settings-outline": "settings-outline",
  "shake-outline": "phone-portrait-outline",
  "share-outline": "share-outline",
  "shield-off-outline": "shield-outline",
  "shield-outline": "shield-outline",
  "shopping-bag-outline": "bag-outline",
  "shopping-cart-outline": "cart-outline",
  "shuffle-2-outline": "shuffle-outline",
  "shuffle-outline": "shuffle-outline",
  "skip-back-outline": "play-skip-back-outline",
  "skip-forward-outline": "play-skip-forward-outline",
  "slash-outline": "ban-outline",
  "smartphone-outline": "phone-portrait-outline",
  "smiling-face-outline": "happy-outline",
  "speaker-outline": "volume-high-outline",
  "square-outline": "square-outline",
  "star-outline": "star-outline",
  "stop-circle-outline": "stop-circle-outline",
  "sun-outline": "sunny-outline",
  "swap-outline": "swap-horizontal-outline",
  "sync-outline": "sync-outline",
  "text-outline": "text-outline",
  "thermometer-minus-outline": "thermometer-outline",
  "thermometer-outline": "thermometer-outline",
  "thermometer-plus-outline": "thermometer-outline",
  "toggle-left-outline": "toggle-outline",
  "toggle-right-outline": "toggle-outline",
  "trash-2-outline": "trash-outline",
  "trash-outline": "trash-outline",
  "trending-down-outline": "trending-down-outline",
  "trending-up-outline": "trending-up-outline",
  "tv-outline": "tv-outline",
  "twitter-outline": "logo-twitter",
  "umbrella-outline": "umbrella-outline",
  "undo-outline": "arrow-undo-outline",
  "unlock-outline": "lock-open-outline",
  "upload-outline": "cloud-upload-outline",
  "video-off-outline": "videocam-off-outline",
  "video-outline": "videocam-outline",
  "volume-down-outline": "volume-low-outline",
  "volume-mute-outline": "volume-mute-outline",
  "volume-off-outline": "volume-off-outline",
  "volume-up-outline": "volume-high-outline",
  "wifi-off-outline": "wifi-outline",
  "wifi-outline": "wifi-outline",
};

export const PAGE_ICONS = Object.keys(EVA_TO_IONICONS);
